<script lang="ts">
  import CrossMark from "../../../icons/CrossMark.svg"

  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import { createEventDispatcher, onMount, onDestroy, getContext } from "svelte"

  import ProductInfo from "./ProductInfo.svelte"
  import IconButton from "../../Common/IconButton.svelte"
  import ProductActions from "../ProductDetails/ProductActions.svelte"

  export let product: RecommendationProduct

  const dispatch = createEventDispatcher()

  function handleOverlayOnClick () {
    dispatch("close")
  }

  onMount(() => {
    document.body.style.overflow = "hidden"
  })

  onDestroy(() => {
    document.body.style.overflow = ""
    removeTabIndexes()
  })

  const { getMain } = getContext<{ getMain: () => HTMLElement }>("main")

  const main = getMain()

  let modal: HTMLDivElement
  let closeIconButton: IconButton

  function getFocusableElements () {
    return document.querySelectorAll(
      'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    )
  }

  function lockElementsOutsideModal () {
    const focusableElements = getFocusableElements()

    for (const element of focusableElements) {
      if (!modal.contains(element)) {
        element.setAttribute("tabindex", "-1")
      }
    }
  }

  function removeTabIndexes () {
    const focusableElements = getFocusableElements()

    for (const element of focusableElements) {
      element.removeAttribute("tabindex")
    }
  }

  $: {
    if (closeIconButton && modal) {
      closeIconButton.focus()

      lockElementsOutsideModal()
    }
  }
</script>

<div
  class="modal-container"
  style="top:{window.scrollY - (main?.offsetTop || 0)}px"
>
  <div
    class="modal-overlay"
    on:click={handleOverlayOnClick}
  >
  </div>
  <div
    bind:this={modal}
    class="modal"
  >
    <IconButton
      bind:this={closeIconButton}
      icon={CrossMark}
      fill="white"
      class="CrossMarkButton"
      label="close"
      on:click={handleOverlayOnClick}
    />
    <div class="modal-content">
      <div class="modal-scrollable-content">
        <ProductInfo product={product} />
      </div>
      <ProductActions product={product} />
    </div>
  </div>
</div>

<style lang="scss">
  .modal-container {
    position: absolute;
    z-index: 1;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding-top: 72px;

    .modal-overlay {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.55);
    }

    :global(.CrossMarkButton) {
      z-index: 9;
    }

    .modal {
      width: calc(1080 / 1280 * 100%);
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .modal-content {
        width: 100%;
        height: min-content;
        max-height: 80vh;
        background: #FFFFFF;
        box-shadow: 0px 0px 1px #1A2B3B, 0px 4px 8px rgba(0, 0, 0, 0.25);
        border-radius: 4px;
        padding: 16px;
        z-index: 999;
        display: flex;
        flex-direction: column;

        .modal-scrollable-content {
          overflow: scroll;
          margin-bottom: 16px;
          padding: 1px;
        }
      }
    }
  }
</style>
